import {
  CreateTeamRequest,
  TeamAdminViewDto,
  UpdateTeamRequest,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const teamsRequests = {
  getTeamsAsAdmin: EndpointDefinition.get<TeamAdminViewDto[], null>({
    name: 'getTeamsAsAdmin',
    route: '/users/admin/teams',
  }),
  createTeam: EndpointDefinition.post<TeamAdminViewDto, CreateTeamRequest, {}>({
    name: 'createTeam',
    route: '/users/admin/teams',
  }),
  updateTeam: EndpointDefinition.patch<
    TeamAdminViewDto,
    UpdateTeamRequest,
    { id: number }
  >({
    name: 'updateTeam',
    route: '/users/admin/teams/:id',
  }),
};
